import {
  Section,
  TextHeading2,
  GroupElementGrid,
  DividerHorizontal,
} from '@ferreri/prever-component-lib';
import dynamic from 'next/dynamic';
import { ServicesExamsCardInfo } from 'medical/components/sections';
import useCurrentAccountContracts from 'contractLegacy/useLegacyCurrentAccountContracts';
import { RewardsSection } from './RewardsSection';

const VPISection = dynamic(() => import('contractLegacy/VPISection'), {
  loading: () => null,
});

export const NewestProductSection = () => {
  const query = useCurrentAccountContracts();

  if (query?.isLoading || query?.hasNoContracts) {
    return null;
  }

  return (
    <>
      <DividerHorizontal />
      <Section>
        <TextHeading2>Indique e ganhe</TextHeading2>
        <GroupElementGrid>
          <RewardsSection />
          <ServicesExamsCardInfo />
          <VPISection />
        </GroupElementGrid>
      </Section>
    </>
  );
};
